mutation OccupationDelete($input: OccupationDeleteInput!) {
  occupationDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
